import { NavLink } from "react-router-dom"
import OwlCarousel from 'react-owl-carousel'
import { useGetSettingQuery } from "../../../../Redux/Apis/siteApi"

export default function Jumbotron(){
    const {data :{home: {jumbotron : {data}}}} = useGetSettingQuery()

    return(
        <div className="container-fluid p-0 pb-5" id="jumbotron">
            {data.lso_slides && <OwlCarousel className="header-carousel position-relative" items={1} loop nav={true} dots={true} center={true} 
                autoplay={true} smartSpeed={1500} navText={[
                    '<i class="fas fa-chevron-left"></i>',
                    '<i class="fas fa-chevron-right"></i>'
                ]}>
                {data.lso_slides.map((row,index) => <div key={index}>
                    <img className="img-fluid" src={row.img_image} alt=""/>
                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center" style={{background: "rgba(53, 53, 53, .7)"}}>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-12 col-lg-8 text-center">
                                    <h5 className="text-white text-uppercase mb-3 animated slideInDown">{row.txt_1}</h5>
                                    <h1 className="display-3 text-white animated slideInDown mb-4">{row.txt_2}</h1>
                                    <p className="fs-5 fw-medium text-white mb-4 pb-2">{row.txe_description}</p>
                                    {row.btn_button1 && row.btn_button1.key.includes("#") ? 
                                        <a className="btn btn-primary py-md-3 me-3 px-md-5 animated slideInLeft" href={`${row.btn_button1.key}`} data-animate="scrolling">{row.btn_button1.value}</a>
                                        :
                                        <NavLink className="btn btn-primary py-md-3 me-3 px-md-5 animated slideInLeft" to={row.btn_button1.key} end caseSensitive>{row.btn_button1.value}</NavLink>
                                    }
                                    {row.btn_button2 && row.btn_button2.key.includes("#") ? 
                                        <a className="btn btn-light py-md-3 px-md-5 animated slideInRight" href={`${row.btn_button2.key}`} data-animate="scrolling">{row.btn_button2.value}</a>
                                        :
                                        <NavLink className="btn btn-light py-md-3 px-md-5 animated slideInRight" to={row.btn_button2.key} end caseSensitive>{row.btn_button2.value}</NavLink>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)}
            </OwlCarousel>}
        </div>
    )
}